module.exports = __webpack_public_path__ + "static/img/recommend_product2_max.0f8af1a2.png";